export enum Feature {
  BaseBranding = 'base-branding',
  CommunicationTemplates = 'communication-templates',
  ContextualCommenting = 'contextual-commenting',
  ContractManagement = 'contract-management',
  ContractroomPurchase = 'contractroom-purchase',
  CrmDynamics = 'crm-dynamics',
  CrmIntegrations = 'crm-integrations',
  CrmSalesforce = 'crm-salesforce',
  CustomColumns = 'custom-columns',
  CustomData = 'custom-data',
  CustomMergeTags = 'custom-merge-tags',
  Dealboard = 'dealboard',
  DealroomPurchase = 'dealroom-purchase',
  DigitalCertificate = 'digital-certificate',
  DocumentAttachments = 'document-attachments',
  ElectronicIdentification = 'electronic-identification',
  EmailSenderAddressOverride = 'email-sender-address-override',
  EmailSenderNameOverride = 'email-sender-name',
  EngageIntegrations = 'engage-integrations',
  ExtendedBranding = 'extended-branding',
  ExtendedElements = 'extended-elements',
  ExternalApiAccess = 'external-api-access',
  FileSizeLimit = 'file-size-limit',
  FullBranding = 'full-branding',
  FullTracking = 'full-tracking',
  GlobalTemplateLibrary = 'global-template-library',
  IdentifyNewRecipients = 'identify-new-recipients',
  LinkBlock = 'link-block',
  MarketingIntegrations = 'marketing-integrations',
  MyDocuments = 'my-documents',
  NonSignableDocuments = 'non-signable-documents',
  OneProduct = 'one-product',
  OtherIntegrations = 'other-integrations',
  PaymentIntegrations = 'payment-integrations',
  ProductLibrary = 'product-library',
  ProvisioningSsoIntegrations = 'provisioning-sso-integrations',
  QES = 'qes',
  RecipientAttachments = 'recipient-attachments',
  RecipientLimit = 'recipient-limit',
  Reports = 'reports',
  RestrictRoomAccess = 'restrict-room-access',
  SigningOrder = 'signing-order',
  Sms = 'sms',
  Tags = 'tags',
  TransferDocumentNotifications = 'transfer-document-notifications',
  UniversalLink = 'universal-link',
  VideoBlock = 'video-block',
  Webhooks = 'webhooks',
  WorkflowIntegrations = 'workflow-integrations',
  ConditionalContent = 'conditional-content',
}
